import { mutateEquipment } from "@/api/equipment/useEquipmentQuery";
import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/alert";
import { LocationAutoComplete } from "@/features/ui/autoComplete/location/location-autoComplate";
import { SitesAutoComplete } from "@/features/ui/autoComplete/site/sites-autoComplete";
import { validateFormValues } from "@/utils/validation";
import styled from "@emotion/styled";
import { Box, Button, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { MasterApiEquipmentsEquipmentIdPutRequest } from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation, useQueryClient } from "react-query";

export const EquipmentUpdateForm = (params: { formatterProps: any }) => {
  const { closeModal } = useModal();
  const queryClient = useQueryClient();
  const { formatterProps } = params;

  const { mutate: updateMutate } = useMutation(
    (params: MasterApiEquipmentsEquipmentIdPutRequest) =>
      mutateEquipment.update(params).mutationFn(params as MasterApiEquipmentsEquipmentIdPutRequest | any),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('equipment');
      },
    }
  )

  const form = useForm({
    initialValues: {
      siteCode: formatterProps.siteCode,
      code: formatterProps.code,
      name: formatterProps.name,
      equipmentType: formatterProps.equipmentType,
      seq: formatterProps.seq,
      toLocationCode: formatterProps.toLocationCode,
      targetLocationCode: formatterProps.targetLocationCode
    },
  });

  const onSubmit = async () => {
    try {
      updateMutate(
        {
          equipmentId: formatterProps?.id,
          equipmentsEquipmentIdDeleteRequest: {
            siteCode: form.values.siteCode as any,
            code: form.values.code as any,
            name: form.values.name as any,
            equipmentType: form.values.equipmentType as any,
            seq: form.values.seq as any,
            toLocationCode: form.values.toLocationCode,
            targetLocationCode: form.values.targetLocationCode
          },
        },
        {
          onSuccess: (res) => {
            closeModal(formatterProps);
            if (res.status === 200) {
              customAlert(
                "설비 수정에 성공하였습니다.",
                "수정 성공",
                "green"
              )
            } else {
              customAlert(
                "설비 수정에 실패하였습니다.",
                "수정 실패",
                "red"
              )
            }
          },
        }
      );
    } catch (e) {
      customAlert(
        "설비 수정에 실패하였습니다.",
        "수정 실패",
        "red"
      )
    }
  };

  return (
    <Box w={320} mx="auto">
      <Form>
        <ModalFieldSet>
          <SitesAutoComplete
            withAsterisk
            label="사업장코드"
            width={"100%"}
            {...form.getInputProps("siteCode")}
            defaultValue={formatterProps?.siteCode}
            error={form.isDirty("siteCode") ? "저장 필요" : ""}
            styles={{
              input: {
                color: form.isDirty("siteCode")
                  ? "cadetblue !important"
                  : "inherit",
                borderColor: form.isDirty("siteCode")
                  ? "cadetblue !important"
                  : "inherit",
              },
              error: { fontSize: 11, color: "cadetblue" },
            }}
          />
          <TextInput
            withAsterisk
            label="설비코드"
            {...form.getInputProps("code")}
            defaultValue={formatterProps?.code}
            disabled
          />
          <TextInput
            withAsterisk
            label="설비명"
            {...form.getInputProps("name")}
            defaultValue={formatterProps?.name}
            error={form.isDirty("name") ? "저장 필요" : ""}
            styles={{
              input: {
                color: form.isDirty("name")
                  ? "cadetblue !important"
                  : "inherit",
                borderColor: form.isDirty("name")
                  ? "cadetblue !important"
                  : "inherit",
              },
              error: { fontSize: 11, color: "cadetblue" },
            }}
          />
          <TextInput
            label="설비유형"
            {...form.getInputProps("equipmentType")}
            defaultValue={formatterProps?.equipmentType}
            error={form.isDirty("equipmentType") ? "저장 필요" : ""}
            styles={{
              input: {
                color: form.isDirty("equipmentType")
                  ? "cadetblue !important"
                  : "inherit",
                borderColor: form.isDirty("equipmentType")
                  ? "cadetblue !important"
                  : "inherit",
              },
              error: { fontSize: 11, color: "cadetblue" },
            }}
          />
          <LocationAutoComplete
            label="입고창고"
            defaultValue={formatterProps?.toLocationCode}
            error={form.isDirty("toLocationCode") ? "저장 필요" : ""}
            {...form.getInputProps("toLocationCode")}
            styles={{
              input: {
                color: form.isDirty("toLocationCode")
                  ? "cadetblue !important"
                  : "inherit",
                borderColor: form.isDirty("toLocationCode")
                  ? "cadetblue !important"
                  : "inherit",
              },
              error: { fontSize: 11, color: "cadetblue" },
            }}
          />

          <LocationAutoComplete
            label="품목 생산 창고"
            defaultValue={formatterProps?.targetLocationCode}
            error={form.isDirty("targetLocationCode") ? "저장 필요" : ""}
            {...form.getInputProps("targetLocationCode")}
            styles={{
              input: {
                color: form.isDirty("targetLocationCode")
                  ? "cadetblue !important"
                  : "inherit",
                borderColor: form.isDirty("targetLocationCode")
                  ? "cadetblue !important"
                  : "inherit",
              },
              error: { fontSize: 11, color: "cadetblue" },
            }}
          />




          <TextInput
            type="number"
            label="시퀀스(순서)"
            {...form.getInputProps("seq")}
            defaultValue={formatterProps?.seq}
            error={form.isDirty("seq") ? "저장 필요" : ""}
            styles={{
              input: {
                color: form.isDirty("seq") ? "cadetblue !important" : "inherit",
                borderColor: form.isDirty("seq")
                  ? "cadetblue !important"
                  : "inherit",
              },
              error: { fontSize: 11, color: "cadetblue" },
            }}
          />
          <ModalConfirmBtnBox>
            <Button color="gray" onClick={closeModal}>
              취소
            </Button>
            <Button
              disabled={validateFormValues({
                pageType: "equipment",
                values: form.values,
              })}
              onClick={onSubmit}
            >
              설비 수정
            </Button>
          </ModalConfirmBtnBox>
        </ModalFieldSet>
      </Form>
    </Box>
  );
};

const Form = styled.div`
  width: 100%;
  height: 100%;
`;

const ModalFieldSet = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ModalConfirmBtnBox = styled.div`
  padding: 24px 0;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;
